import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHelpComponent } from "./med-icon-help.component";

@NgModule({
  declarations: [
    MedIconHelpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHelpComponent,
  ],
})
export class MedIconHelpModule { }
